import Context from "../../context/Context";
import Dataset from "./Dataset";
import FieldNames from "./FieldNames";
import * as aiimUtil from "../util/aiimUtil";
import * as searchUtil from "../util/searchUtil";
import * as selectionUtil from "../util/selectionUtil";

export default class People extends Dataset {

  areaIDField = FieldNames.PEOPLE_AREA_ID;
  emailField = FieldNames.PEOPLE_EMAIL;
  fullNameField = FieldNames.PEOPLE_FULLNAME;
  unitIDField = FieldNames.PEOPLE_UNIT_ID;
  type = "feature";

  checkSchema() {
    const promise = new Promise((resolve,reject) => {
      if (this.layer2D) {
        const layer = this.layer2D;
        layer.when(() => {
          this.checkFieldNameProperty("areaIDField",layer.fields);
          this.checkFieldNameProperty("emailField",layer.fields);
          this.checkFieldNameProperty("fullNameField",layer.fields);
          this.checkFieldNameProperty("unitIDField",layer.fields);
          resolve();
        }).catch(ex => {
          console.log("Failed to load dataset layer:",layer.title);
          console.error(ex);
          resolve();
        });
      } else {
        resolve();
      }
    });
    return promise;
  }

  getSource() {
    return Context.getInstance().aiim.datasets.categories.findSourceByKey("People"); // TODO
  }

  getUnitID(peopleFeature) {
    return aiimUtil.getAttributeValue(peopleFeature.attributes,this.unitIDField);
  }

  isPeopleLayer(layer,fields) {
    if (fields) {
      let count = 0;
      const matched = fields.some((field) => {
        const lc = field.name.toLowerCase();
        if (lc === FieldNames.PEOPLE_FULLNAME.toLowerCase() ||
            lc === FieldNames.PEOPLE_EMAIL.toLowerCase()) {
          count++;
          if (count >= 2) return true;
        }
        return false;
      });
      return matched;
    }
    return false;
  }

  queryAppUserAssignments() {
    const promise = new Promise((resolve,reject) => {
      const url = this.url;
      const areaIDField = this.areaIDField;
      const emailField = this.emailField;
      const fullNameField = this.fullNameField;
      const unitIDField = this.unitIDField;
      let email = Context.instance.user.getEmail();
      let fullName = Context.instance.user.getFullName();
      let source = this.getSource();
      let matchFullName = false;
      let features, areaIDs = [], unitIDs = [];
      let info = {
        occupantFeatures: features,
        areaIDs: areaIDs,
        unitIDs: unitIDs
      }

      //fullName = "Victor Welch";
      //email = "victor.welch@esri.com";
      //areaIDs.push("hotel-dabf794839d440f3984e3c74d36dfc13");

      if (typeof email !== "string") {
        resolve(info);
        return;
      }
      let fld = "UPPER("+emailField+")"; // case insensitive match
      let uc = email.toUpperCase();

      searchUtil.queryFieldValue(source,url,fld,uc).then(result => {
        features = result && result.features;
      }).then(() => {
        if (features && features.length > 0 && matchFullName) {
          features = features.filter(f => {
            let v = aiimUtil.getAttributeValue(f.attributes,fullNameField);
            if (fullName && (v === fullName)) {
              return true;
            }
            return false;
          })
        }
      }).then(() => {
        if (features) {
          features.forEach(f => {
            let areaID = aiimUtil.getAttributeValue(f.attributes,areaIDField);
            let unitID = aiimUtil.getAttributeValue(f.attributes,unitIDField);
            if (areaID && (areaIDs.indexOf(areaID) === -1)) areaIDs.push(areaID);
            if (unitID && (unitIDs.indexOf(unitID) === -1)) unitIDs.push(unitID);
          })
        }
      }).then(() => {
        info.occupantFeatures = features;
        resolve(info);
        //console.log("queryAppUserAssignments",info);
      }).catch(ex => {
        reject(ex);
      });
    });
    return promise;
  }

  async queryOccupantAreaIds(email,includeUnrestricted,matchAreaIds) {
    if (!this.url) return;
    if (typeof email === "string" && email.length > 0) {
      email = email.toUpperCase();
    } else {
      return;
    }
    let areaIds = [];
    const areaIDField = this.areaIDField;
    const emailField = this.emailField;
    const url = Context.checkMixedContent(this.url);
    const lib = Context.getInstance().lib;
    const task = new lib.esri.QueryTask({url: url});
    const query = new lib.esri.Query();
    query.outFields = [areaIDField];
    query.returnGeometry = false;
    query.returnZ = false;
    query.where = "UPPER("+emailField+") = '"+selectionUtil.escSqlQuote(email)+"'";
    const result = await task.execute(query);
    if (result && result.features) {
      result.features.forEach(f => {
        const areaId = aiimUtil.getAttributeValue(f.attributes,areaIDField);
        if (areaId && !areaIds.includes(areaId)) areaIds.push(areaId);
      })
    }
    if (includeUnrestricted) {
      const areas = Context.instance.aiim.datasets && Context.instance.aiim.datasets.areas;
      if (areas) {
        const ids = await areas.queryUnrestrictedIDs();
        if (ids) {
          ids.forEach(areaId => {
            if (areaId && !areaIds.includes(areaId)) areaIds.push(areaId);
          })
        }
      }
    }
    if (matchAreaIds) {
      areaIds = areaIds.filter(areaId => {
        return matchAreaIds.includes(areaId);
      })
    }
    return areaIds;
  }

}
